// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BoxPlotOutlinedSvg from "@fishx/icons-svg/es/asn/BoxPlotOutlined";
import FishxIcon from '../components/FishxIcon';

var BoxPlotOutlined = function BoxPlotOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotOutlinedSvg
  }));
};

BoxPlotOutlined.displayName = 'BoxPlotOutlined';
export default React.forwardRef(BoxPlotOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BoxPlotOutlined.js
// module id = 2116
// module chunks = 0